// extracted by css-extract-rspack-plugin
export default {"wrapper":"_cde1c573","content":"_843aa3a9"};